module.exports = __webpack_public_path__ + "assets/img/modal-avatar-e646f035.png";